import { makeStyles } from 'tss-react/mui';

import { chipClasses } from '@mui/material';

export default makeStyles({ name: 'VersionMenuItem' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        borderRadius: 8,
        padding: 16,
        overflow: 'hidden'
    },
    selected: {
        background: '#F5F5F5 !important'
    },
    data: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        alignItems: 'flex-start',
        flexGrow: 1,
        overflow: 'hidden'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    version: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap'
    },
    updated: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    },
    datetime: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        alignItems: 'flex-end',
        flexShrink: 1
    },
    date: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap'
    },
    time: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap'
    },
    current: {
        height: 20,
        border: '1px solid #C1E8D4',
        [`& .${chipClasses.label}`]: {
            paddingLeft: 4,
            paddingRight: 4,
            color: '#05A569',
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '16px'
        }
    },
    preview: {
        display: 'flex',
        padding: '8px 12px',
        gap: 8,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 12,
        background: '#FFF',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    }
});
